import { render, staticRenderFns } from "./form.component.vue?vue&type=template&id=dd0b4ff4"
import script from "./form.component.js?vue&type=script&lang=js&external"
export * from "./form.component.js?vue&type=script&lang=js&external"
import style0 from "./form.component.vue?vue&type=style&index=0&id=dd0b4ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports